import { Component, NgZone, OnInit } from '@angular/core';
import { PROJECTS } from '@core/enum/projects.enum';
import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';

import { RECAPTCHA_CONFIG } from './recaptcha.component.config';
import { ModalService } from '../../modal.service';
import { ftdUrl } from '@core/layouts/default/default.config';

@Component({
  selector: 'shell-recaptcha',
  templateUrl: './recaptcha.component.html',
})
export class RecaptchaComponent implements OnInit {
  config: ModalErrorConfig;
  modalError: any;
  constructor(
    private modalService: ModalService,
    public microFrontendRouter: MicroFrontendRouter,
    public messageBusService: MessageBusService,
    public ngZone: NgZone,
  ) {}

  closeModal() {
    switch (this.modalError?.project) {
      case PROJECTS.ACC:
        window.location.href = window.location.origin;
        break;
      case PROJECTS.PLD:
        this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
        break;
      case PROJECTS.FTD:
        window.location.href = window.location.origin + ftdUrl.firstPage;
        break;
    }
    this.modalService.close();
    window.location.reload();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.modalError = this.messageBusService.getValue('shell', 'modal.error');
        this.config = RECAPTCHA_CONFIG.get(this.modalError?.project) as ModalErrorConfig;
      });
    });
  }
}
